export const DEFAULT_COUNTRY_RISK_RATINGS = [
  { country: "Afghanistan", rating: "SANCTIONED_TARGETED" },
  { country: "Albania", rating: "SANCTIONED_TARGETED" },
  { country: "Algeria", rating: "HIGH" },
  { country: "American Samoa", rating: "HIGH" },
  { country: "Andorra", rating: "MEDIUM" },
  { country: "Angola", rating: "HIGH" },
  { country: "Anguilla", rating: "HIGH" },
  { country: "Antigua & Barbuda", rating: "HIGH" },
  { country: "Argentina", rating: "HIGH" },
  { country: "Armenia", rating: "HIGH" },
  { country: "Aruba", rating: "MEDIUM" },
  { country: "Australia", rating: "LOW" },
  { country: "Austria", rating: "LOW" },
  { country: "Azerbaijan", rating: "HIGH" },
  { country: "Bahamas", rating: "HIGH" },
  { country: "Bahrain", rating: "HIGH" },
  { country: "Bangladesh", rating: "HIGH" },
  { country: "Barbados", rating: "MEDIUM" },
  { country: "Belarus", rating: "SANCTIONED_COMPREHENSIVE" },
  { country: "Belgium", rating: "LOW" },
  { country: "Belize", rating: "HIGH" },
  { country: "Benin", rating: "HIGH" },
  { country: "Bermuda", rating: "MEDIUM" },
  { country: "Bhutan", rating: "HIGH" },
  { country: "Bolivia", rating: "HIGH" },
  { country: "Bosnia-Herzegovina", rating: "SANCTIONED_TARGETED" },
  { country: "Botswana", rating: "HIGH" },
  { country: "Bouvet Island", rating: "HIGH" },
  { country: "Brazil", rating: "HIGH" },
  { country: "British Indian Ocean Territory", rating: "HIGH" },
  { country: "British Virgin Islands", rating: "HIGH" },
  { country: "Brunei", rating: "HIGH" },
  { country: "Bulgaria", rating: "HIGH" },
  { country: "Burkina Faso", rating: "HIGH" },
  { country: "Burundi", rating: "HIGH" },
  { country: "Cambodia", rating: "HIGH" },
  { country: "Cameroon", rating: "HIGH" },
  { country: "Canada", rating: "LOW" },
  { country: "Canary Islands", rating: "MEDIUM" },
  { country: "Cape Verde", rating: "HIGH" },
  { country: "Cayman Islands", rating: "MEDIUM" },
  { country: "Central African Republic", rating: "SANCTIONED_TARGETED" },
  { country: "Chad", rating: "HIGH" },
  { country: "Chile", rating: "MEDIUM" },
  { country: "China", rating: "MEDIUM" },
  { country: "Christmas Island", rating: "HIGH" },
  { country: "Cocos Islands", rating: "HIGH" },
  { country: "Colombia", rating: "HIGH" },
  { country: "Comoros", rating: "HIGH" },
  { country: "Cook Islands", rating: "HIGH" },
  { country: "Costa Rica", rating: "MEDIUM" },
  { country: "Cote d’Ivoire", rating: "HIGH" },
  { country: "Croatia", rating: "HIGH" },
  { country: "Cuba", rating: "SANCTIONED_COMPREHENSIVE" },
  { country: "Curacao", rating: "HIGH" },
  { country: "Cyprus", rating: "LOW" },
  { country: "Czech Republic", rating: "LOW" },
  { country: "Democratic Republic of the Congo", rating: "SANCTIONED_TARGETED" },
  { country: "Denmark", rating: "LOW" },
  { country: "Djibouti", rating: "HIGH" },
  { country: "Dominica", rating: "HIGH" },
  { country: "Dominican Republic", rating: "HIGH" },
  { country: "East Timor", rating: "HIGH" },
  { country: "Ecuador", rating: "HIGH" },
  { country: "Egypt", rating: "HIGH" },
  { country: "El Salvador", rating: "HIGH" },
  { country: "Equatorial Guinea", rating: "HIGH" },
  { country: "Eritrea", rating: "HIGH" },
  { country: "Estonia", rating: "LOW" },
  { country: "Eswatini (formerly named as Swaziland)", rating: "HIGH" },
  { country: "Ethiopia", rating: "SANCTIONED_TARGETED" },
  { country: "Falkland Islands", rating: "HIGH" },
  { country: "Faroe Islands", rating: "MEDIUM" },
  { country: "Fiji", rating: "HIGH" },
  { country: "Finland", rating: "LOW" },
  { country: "France", rating: "LOW" },
  { country: "French Guiana", rating: "HIGH" },
  { country: "French Polynesia", rating: "HIGH" },
  { country: "French Southern Territories", rating: "HIGH" },
  { country: "Gabon", rating: "HIGH" },
  { country: "Gambia", rating: "HIGH" },
  { country: "Georgia", rating: "HIGH" },
  { country: "Germany", rating: "LOW" },
  { country: "Ghana", rating: "HIGH" },
  { country: "Gibraltar", rating: "MEDIUM" },
  { country: "Greece", rating: "LOW" },
  { country: "Greenland", rating: "HIGH" },
  { country: "Grenada", rating: "HIGH" },
  { country: "Guadeloupe", rating: "HIGH" },
  { country: "Guam", rating: "HIGH" },
  { country: "Guatemala", rating: "HIGH" },
  { country: "Guernsey C.I.", rating: "MEDIUM" },
  { country: "Guinea", rating: "HIGH" },
  { country: "Guinea-Bissau", rating: "HIGH" },
  { country: "Guyana", rating: "HIGH" },
  { country: "Haiti", rating: "HIGH" },
  { country: "Heard & McDonald Islands", rating: "HIGH" },
  { country: "Honduras", rating: "HIGH" },
  { country: "Hong Kong", rating: "LOW" },
  { country: "Hungary", rating: "LOW" },
  { country: "Iceland", rating: "HIGH" },
  { country: "India", rating: "HIGH" },
  { country: "Indonesia", rating: "HIGH" },
  { country: "Iran", rating: "SANCTIONED_COMPREHENSIVE" },
  { country: "Iraq", rating: "SANCTIONED_TARGETED" },
  { country: "Ireland", rating: "LOW" },
  { country: "Isle of Man", rating: "MEDIUM" },
  { country: "Israel", rating: "MEDIUM" },
  { country: "Italy", rating: "LOW" },
  { country: "Jamaica", rating: "HIGH" },
  { country: "Japan", rating: "LOW" },
  { country: "Jersey C.I.", rating: "MEDIUM" },
  { country: "Jordan", rating: "HIGH" },
  { country: "Kazakhstan", rating: "HIGH" },
  { country: "Kenya", rating: "HIGH" },
  { country: "Kiribati", rating: "HIGH" },
  { country: "Kosovo", rating: "SANCTIONED_TARGETED" },
  { country: "Kuwait", rating: "HIGH" },
  { country: "Kyrgyzstan", rating: "HIGH" },
  { country: "La Reunion", rating: "HIGH" },
  { country: "Laos", rating: "HIGH" },
  { country: "Latvia", rating: "MEDIUM" },
  { country: "Lebanon", rating: "SANCTIONED_TARGETED" },
  { country: "Lesotho", rating: "HIGH" },
  { country: "Liberia", rating: "HIGH" },
  { country: "Libya", rating: "SANCTIONED_TARGETED" },
  { country: "Liechtenstein", rating: "MEDIUM" },
  { country: "Lithuania", rating: "MEDIUM" },
  { country: "Luxembourg", rating: "LOW" },
  { country: "Macau", rating: "MEDIUM" },
  { country: "Madagascar", rating: "HIGH" },
  { country: "Madeira", rating: "MEDIUM" },
  { country: "Malawi", rating: "HIGH" },
  { country: "Malaysia", rating: "MEDIUM" },
  { country: "Maldives", rating: "HIGH" },
  { country: "Mali", rating: "SANCTIONED_TARGETED" },
  { country: "Malta", rating: "HIGH" },
  { country: "Marshall Islands", rating: "HIGH" },
  { country: "Martinique", rating: "HIGH" },
  { country: "Mauritania", rating: "HIGH" },
  { country: "Mauritius", rating: "HIGH" },
  { country: "Mayotte", rating: "HIGH" },
  { country: "Mexico", rating: "HIGH" },
  { country: "Micronesia", rating: "HIGH" },
  { country: "Moldova", rating: "HIGH" },
  { country: "Monaco", rating: "HIGH" },
  { country: "Mongolia", rating: "HIGH" },
  { country: "Montenegro", rating: "HIGH" },
  { country: "Montserrat", rating: "HIGH" },
  { country: "Morocco", rating: "HIGH" },
  { country: "Mozambique", rating: "HIGH" },
  { country: "Myanmar", rating: "SANCTIONED_TARGETED" },
  { country: "Namibia", rating: "HIGH" },
  { country: "Nauru", rating: "HIGH" },
  { country: "Nepal", rating: "HIGH" },
  { country: "Netherlands", rating: "LOW" },
  { country: "Netherlands Antilles", rating: "MEDIUM" },
  { country: "New Caledonia", rating: "HIGH" },
  { country: "New Zealand", rating: "LOW" },
  { country: "Nicaragua", rating: "SANCTIONED_TARGETED" },
  { country: "Niger", rating: "HIGH" },
  { country: "Nigeria", rating: "HIGH" },
  { country: "Niue", rating: "HIGH" },
  { country: "Norfolk Island", rating: "HIGH" },
  { country: "North Korea", rating: "SANCTIONED_COMPREHENSIVE" },
  { country: "North Macedonia", rating: "SANCTIONED_TARGETED" },
  { country: "Northern Mariana Islands", rating: "HIGH" },
  { country: "Norway", rating: "LOW" },
  { country: "Oman", rating: "MEDIUM" },
  { country: "Pakistan", rating: "HIGH" },
  { country: "Palau", rating: "HIGH" },
  { country: "Palestine", rating: "HIGH" },
  { country: "Panama", rating: "HIGH" },
  { country: "Papua New Guinea", rating: "HIGH" },
  { country: "Paraguay", rating: "HIGH" },
  { country: "Peru", rating: "HIGH" },
  { country: "Philippines", rating: "HIGH" },
  { country: "Pitcairn", rating: "HIGH" },
  { country: "Poland", rating: "MEDIUM" },
  { country: "Portugal", rating: "LOW" },
  { country: "Puerto Rico", rating: "HIGH" },
  { country: "Qatar", rating: "MEDIUM" },
  { country: "Republic of the Congo", rating: "HIGH" },
  { country: "Romania", rating: "MEDIUM" },
  { country: "Russia", rating: "SANCTIONED_TARGETED" },
  { country: "Rwanda", rating: "HIGH" },
  { country: "Saint Barthelemy", rating: "MEDIUM" },
  { country: "Saint Helena", rating: "HIGH" },
  { country: "Saint Kitts & Nevis", rating: "HIGH" },
  { country: "Saint Lucia", rating: "HIGH" },
  { country: "Saint Pierre & Micquelon", rating: "HIGH" },
  { country: "Saint Vincent & the Grenadines", rating: "HIGH" },
  { country: "Samoa", rating: "HIGH" },
  { country: "San Marino", rating: "HIGH" },
  { country: "Sao Tome & Principe", rating: "HIGH" },
  { country: "Saudi Arabia", rating: "HIGH" },
  { country: "Scalbard & Jan Mayen Islands", rating: "HIGH" },
  { country: "Senegal", rating: "MEDIUM" },
  { country: "Serbia", rating: "HIGH" },
  { country: "Seychelles", rating: "HIGH" },
  { country: "Sierra Leone", rating: "HIGH" },
  { country: "Singapore", rating: "LOW" },
  { country: "Sint Maarten", rating: "MEDIUM" },
  { country: "Slovakia", rating: "MEDIUM" },
  { country: "Slovenia", rating: "LOW" },
  { country: "Solomon Islands", rating: "HIGH" },
  { country: "Somalia", rating: "SANCTIONED_TARGETED" },
  { country: "South Africa", rating: "HIGH" },
  { country: "South Georgia & South Sandwich Islands", rating: "HIGH" },
  { country: "South Korea", rating: "MEDIUM" },
  { country: "South Sudan", rating: "SANCTIONED_TARGETED" },
  { country: "Spain", rating: "LOW" },
  { country: "Sri Lanka", rating: "HIGH" },
  { country: "Sudan (including Darfur)", rating: "SANCTIONED_TARGETED" },
  { country: "Suriname", rating: "HIGH" },
  { country: "Sweden", rating: "LOW" },
  { country: "Switzerland", rating: "LOW" },
  { country: "Syria", rating: "SANCTIONED_COMPREHENSIVE" },
  { country: "Taiwan", rating: "MEDIUM" },
  { country: "Tajikistan", rating: "HIGH" },
  { country: "Tanzania", rating: "HIGH" },
  { country: "Territories of Crimea - Sevastopol, Donetsk, Luhansk, Zaporizhzhia and Kherson", rating: "SANCTIONED_COMPREHENSIVE" },
  { country: "Thailand", rating: "HIGH" },
  { country: "Togo", rating: "HIGH" },
  { country: "Tokelau Islands", rating: "HIGH" },
  { country: "Tonga", rating: "HIGH" },
  { country: "Trinidad & Tobago", rating: "MEDIUM" },
  { country: "Tunisia", rating: "HIGH" },
  { country: "Turkey", rating: "HIGH" },
  { country: "Turkmenistan", rating: "HIGH" },
  { country: "Turks & Caicos Islands", rating: "HIGH" },
  { country: "Tuvalu", rating: "HIGH" },
  { country: "Uganda", rating: "HIGH" },
  { country: "Ukraine", rating: "HIGH" },
  { country: "United Arab Emirates", rating: "MEDIUM" },
  { country: "United Kingdom", rating: "LOW" },
  { country: "United States", rating: "LOW" },
  { country: "Uruguay", rating: "MEDIUM" },
  { country: "US Minor Outlying Islands", rating: "HIGH" },
  { country: "US Virgin Islands", rating: "HIGH" },
  { country: "Uzbekistan", rating: "HIGH" },
  { country: "Vanuatu", rating: "HIGH" },
  { country: "Vatican City", rating: "HIGH" },
  { country: "Venezuela", rating: "SANCTIONED_TARGETED" },
  { country: "Vietnam", rating: "HIGH" },
  { country: "Wallis & Futuna Islands", rating: "HIGH" },
  { country: "Yemen", rating: "SANCTIONED_TARGETED" },
  { country: "Zambia", rating: "HIGH" },
  { country: "Zimbabwe", rating: "HIGH" },
];
